import React, { Component } from 'react';

import css from 'styles/components/common/singleSizeChart.scss';
const countryOptions = new Map();
countryOptions.set('usac', 'United States & Canada');
countryOptions.set('uk', 'United Kingdom');
countryOptions.set('eur', 'Europe');
countryOptions.set('in', 'Heel-Toe Measurements (in)');
countryOptions.set('cm', 'Heel-Toe Measurements (cm)');

export class SingleSizeChart extends Component {

  constructor (props) {
    super(props);

    const { sizeGuide, gender } = this.props;
    const { slotData: { sizingGuides } } = sizeGuide;
    this.tableGuide = new Map();
    const mapProps = (prefix, name) => ({
      name,
      value: prefix,
      heading: sizingGuides[`${name}heading`] || `${name} Shoe Size Chart`,
      table: sizingGuides[`${prefix}table`]
    });

    let activeTab;

    if (gender[0] === 'Girls' || gender[0] === 'Boys') {
      this.tableGuide.set('Infant', mapProps('infant', 'Infants\''));
      this.tableGuide.set('Toddler', mapProps('toddler', 'Toddlers\''));
      this.tableGuide.set('Littlekid', mapProps('littlekids', 'Little Kids\''));
      this.tableGuide.set('Bigkid', mapProps('bigkids', 'Big Kids\''));
      activeTab = 'infant';
    } else if (gender.length > 1) {
      this.tableGuide.set('Women', mapProps('womens', 'Women\'s'));
      this.tableGuide.set('Men', mapProps('mens', 'Men\'s'));
      activeTab = 'womens';
    } else if (gender[0] === 'Women') {
      this.tableGuide.set('Women', mapProps('womens', 'Women\'s'));
      activeTab = 'womens';
    } else if (gender[0] === 'Men') {
      this.tableGuide.set('Men', mapProps('mens', 'Men\'s'));
      activeTab = 'mens';
    }
    // need to set default view of the size table based on the mapped gender sent from pdp
    // eslint-disable-next-line react/state-in-constructor
    this.state = { activeTab };
  }

  showHide = e => {
    e.preventDefault();
    this.setState({ activeTab: e.target.dataset.index });
  };

  makeTabs = () => {
    const tabTable = [];
    this.tableGuide.forEach((value, key) => {
      const tableName = `${key}-table`;
      tabTable.push(<li key={`${key}-tab`}>
        <a
          aria-controls={tableName}
          data-index={value.value}
          onClick={this.showHide}
          href={`#${tableName}`}>{value.name}</a></li>);
    });
    return tabTable;
  };

  makeTabRow = newTable => {
    newTable.push(<ul aria-label="Tabs for sizing table" key="test">
      {this.makeTabs()}
    </ul>);
    return newTable;
  };

  makeRows = (table, item) => {
    const list = [];

    countryOptions.forEach((country, key) => {
      list.push(<tr key={`${country}${item}`}>
        <th scope="row">{country}</th>
        {table[key].map((size, index) => (
          <td key={`${key}_${size}_${index}`}>{size}</td>
        ))}
      </tr>);
    });
    return list;
  };

  makeTable = () => {
    const newTable = [];
    const { activeTab } = this.state;
    this.tableGuide.size > 1 && this.makeTabRow(newTable);

    this.tableGuide.forEach((value, key) => {
      const currentTable = value.table;
      const currentHeading = value.heading;
      const currentValue = value.value;
      if (currentValue === activeTab) {
        newTable.push(
          <div key={`${key}-tableWrapper`}>
            <table
              className={css.sizeTable}
              id={`${currentValue}-table`}
              aria-labelledby="sizeChart"
              key={`${currentValue}-table`}>
              <caption>{`${currentHeading} in various measurements`}</caption>
              <thead><tr>
                <th scope="col">Unit</th>
                <th colSpan={currentTable.usac.length} scope="col">{currentHeading}</th>
              </tr>
              </thead>
              <tbody>
                {this.makeRows(currentTable, currentValue)}
              </tbody>
            </table>
          </div>);
      }
    });
    return newTable;
  };

  render () {
    const { sizeGuide, gender, sizeGuide: { slotData: { sizingGuides: { bottomcopy, bottomcopybold, chartheading } } } } = this.props;
    if (!(sizeGuide && gender)) {
      return null;
    }
    return (
      <section className={css.mSizingGuide}>
        <div className={css.top}>
          <h3 id="sizeChart">{chartheading}</h3>
          <p>{bottomcopy}</p>
          <p>{bottomcopybold}</p>
        </div>
        {this.makeTable()}
      </section>
    );
  }
}

export default SingleSizeChart;
